module.exports = __webpack_public_path__ + "assets/platform-circulo.5c56108b.svg";